// extracted by mini-css-extract-plugin
module.exports = {"table":"styles_table__16r-u","tableRow":"styles_tableRow__3nbLD","sorted":"styles_sorted__1_Upj"};